import {
  CompletionTargetUnit,
  HabitSchedule,
  RruleReferenceDate,
} from '@griply/types';

import { EVERY_DAY_RRULE } from './constants';

export const createDefaultSchedule = (startDate: Date): HabitSchedule => ({
  startDate,
  rrule: {
    format: EVERY_DAY_RRULE,
    referenceDate: RruleReferenceDate.StartDate,
  },
  frequency: null,
  completionTarget: {
    unit: CompletionTargetUnit.Day,
    count: 1,
  },
  entries: [],
  endDate: null,
});
